<template>
  <div>
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
    <div class="content_box">
      <el-row style="margin:5px 0">
        <el-button size="mini" class="btn" type="primary" @click="onAddSave" v-acl="RMC_PROD_FARM_SAVE" v-if="rmcProduceFarmId==='0'&&(!detailForm.auditStatus||detailForm.auditStatus==='Draft')&&ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP')!==-1">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onEditSave" v-acl="RMC_PROD_FARM_SAVE" v-if="rmcProduceFarmId!=='0'&&(!detailForm.auditStatus||detailForm.auditStatus==='Draft')&&ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP')!==-1">保存</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onSubmit" v-acl="RMC_PROD_FARM_SUBMIT" v-if="detailForm.auditStatus!=='PendingApproval'&&ms_roles.indexOf('QSPI_RMC_PRODUCE_SPONS_SUPP')!==-1">提交</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onApprove" v-acl="RMC_PROD_FARM_APPROVE" v-if="detailForm.auditStatus==='PendingApproval'&&ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS')!==-1">批准</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onReturn" v-acl="RMC_PROD_FARM_RETURN" v-if="detailForm.auditStatus==='PendingApproval'&&ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS')!==-1">退回</el-button>
      </el-row>
      <el-form :model="detailForm" ref="detailForm" label-width="120px">
        <div class="within_box">
          <div class="title_box">
            <p class="line"></p>
            <p class="title">农场清单</p>
          </div>
          <div class="form_box">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="Category3" prop="category3Code">
                  <el-select v-model="detailForm.category3Code" :disabled="isDisabled||isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in category3CodeOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Sponsor" prop="sponsorName">
                  <el-input v-model="detailForm.sponsorName" disabled style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Farm Group" prop="farmGroupId" :rules="rules.farmGroupId" class="is-required">
                  <el-select v-model="detailForm.farmGroupId" clearable :disabled="isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in farmGroupOptions" :label="item.farmGroup" :value="item.rmcProduceFarmGroupId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态" prop="auditStatus">
                  <el-select v-model="detailForm.auditStatus" disabled placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in auditStatusOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="农场" prop="farmName" :rules="rules.farmName" class="is-required">
                  <el-input v-model="detailForm.farmName" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="品类" prop="varieties" :rules="rules.varieties" class="is-required">
                  <el-select v-model="detailForm.varieties" disabled multiple placeholder="请选择" style="width:100%" class="multiple_sel">
                    <el-option :key="index" v-for="(item,index) in varietiesOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="农场地址" prop="farmAddress" :rules="rules.farmAddress" class="is-required">
                  <el-input v-model="detailForm.farmAddress" :disabled="isForbidden" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="农场规模(亩)" prop="plantingScale" :rules="rules.plantingScale" class="is-required">
                  <el-input v-model="detailForm.plantingScale" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="作物" prop="crop" :rules="rules.crop" class="is-required">
                  <el-select v-model="detailForm.crop" :disabled="isForbidden" @change="cropChange" clearable multiple placeholder="请选择" style="width:100%" class="multiple_sel">
                    <el-option :key="index" v-for="(item,index) in cropOptions" :label="item.chineseValue" :value="item.code"></el-option>
                  </el-select>
                  <!-- <ic-select v-model="detailForm.crop" :disabled="isForbidden" @change="cropChange" table="TT_RMC_PRODUCE_FARM" field="CROP" multiple clearable placeholder="请选择" style="width:100%" class="multiple_sel"></ic-select> -->
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="种植方式" prop="plantingMode" :rules="rules.plantingMode" class="is-required">
                  <el-select v-model="detailForm.plantingMode" :disabled="isForbidden" clearable multiple placeholder="请选择" style="width:100%" class="multiple_sel">
                    <el-option :key="index" v-for="(item,index) in plantingModeOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="农场状态" prop="farmStatus" :rules="rules.farmStatus" class="is-required">
                  <el-select v-model="detailForm.farmStatus" :disabled="isForbidden" placeholder="请选择" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in farmStatusOptions" :label="item.object" :value="item.key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="定植期" prop="plantingPeriod" :rules="rules.plantingPeriod" class="is-required">
                  <el-input v-model="detailForm.plantingPeriod" :disabled="isForbidden" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="采购期" prop="harvestTime" :rules="rules.harvestTime" class="is-required">
                  <el-input v-model="detailForm.harvestTime" :disabled="isForbidden" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="联系人" prop="farmContacts" :rules="rules.farmContacts" class="is-required">
                  <el-input v-model="detailForm.farmContacts" :disabled="isForbidden" clearable placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系电话" prop="contactInformation" :rules="rules.contactInformation" class="is-required">
                  <el-input v-model="detailForm.contactInformation" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="其他" prop="comments">
                  <el-input v-model="detailForm.comments" :disabled="isForbidden" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="$route.query.from === 'edit'">
              <el-col :span="24">
                <el-form-item label="上次修改原因" prop="lastUpdateReason" class="is-required">
                  <el-input v-model="lastUpdateReason" disabled type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="修改原因" prop="updateReason" :rules="rules.updateReason" class="is-required">
                  <el-input v-model="detailForm.updateReason" :disabled="isForbidden" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog title="退回意见" :visible.sync="dialogReturnVisible" width="30%" :close-on-click-modal="false" @close="onClose" class="fpa">
      <el-form ref="returnForm" :model="returnForm" :rules="returnFormRules">
        <el-form-item prop="returnedReason">
          <el-input v-model="returnForm.returnedReason" type="textarea" maxlength="1000" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"></el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center">
        <el-button size="mini" @click="onConfirm" type="primary">确定</el-button>
        <el-button size="mini" @click="onClose">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import rmcProdFarmApi from "@/api/rmcProduce/farm";
export default {
  name: "rmcProdFarmDetail",
  components: {
    IcSelect,
  },
  data() {
    return {
      rules: {
        farmGroupId: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error("请选择Farm Group");
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "change",
          },
        ],
        farmName: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error("请输入农场");
                return callback(new Error(" "));
              }
              var reg = /^.{1,100}$/;
              if (!reg.test(value)) {
                this.$message.error(
                  "字段“农场”已超出数据库长度要求（长度：100），请删减."
                );
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        farmAddress: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error("请输入农场地址");
                return callback(new Error(" "));
              }
              var reg = /^.{1,100}$/;
              if (!reg.test(value)) {
                this.$message.error(
                  "字段“农场地址”已超出数据库长度要求(长度:100)，请删减."
                );
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        plantingScale: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error("请输入农场规模(亩)");
                return callback(new Error(" "));
              }
              var reg = /^[0-9]+(\.[0-9]{1,2})?$/;
              if (!reg.test(value)) {
                this.$message.error(
                  "字段“农场规模(亩)”输入格式不满足要求（格式：数字,最多两位小数），请检查."
                );
                return callback(new Error(" "));
              }
              var reg1 = /^.{1,10}$/;
              if (!reg1.test(value)) {
                this.$message.error(
                  "字段“农场规模(亩)”已超出数据库长度要求(长度:10)，请删减."
                );
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        varieties: [
          {
            validator: (rule, value, callback) => {
              console.log("varieties", value);
              if (!value || value.length === 0) {
                this.$message.error("请选择品类");
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "change",
          },
        ],
        crop: [
          {
            validator: (rule, value, callback) => {
              console.log("crop", value);
              if (!value || value.length === 0) {
                this.$message.error("请选择作物");
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "change",
          },
        ],
        plantingMode: [
          {
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                console.log("plantingMode", value);
                this.$message.error("请选择种植方式");
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "change",
          },
        ],
        farmStatus: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                console.log("farmStatus", value);
                this.$message.error("请选择农场状态");
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "change",
          },
        ],
        plantingPeriod: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error("请输入定植期");
                return callback(new Error(" "));
              }
              var reg = /^.{1,100}$/;
              if (!reg.test(value)) {
                this.$message.error(
                  "字段“定植期”已超出数据库长度要求（长度：100），请删减."
                );
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        harvestTime: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error("请输入采购期");
                return callback(new Error(" "));
              }
              var reg = /^.{1,100}$/;
              if (!reg.test(value)) {
                this.$message.error(
                  "字段“采购期”已超出数据库长度要求（长度：100），请删减."
                );
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        farmContacts: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error("请输入联系人");
                return callback(new Error(" "));
              }
              var reg = /^.{1,100}$/;
              if (!reg.test(value)) {
                this.$message.error(
                  "字段“联系人”已超出数据库长度要求（长度：100），请删减."
                );
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        contactInformation: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error("请输入联系电话");
                return callback(new Error(" "));
              }
              var reg = /^.{1,100}$/;
              if (!reg.test(value)) {
                this.$message.error(
                  "字段“联系电话”已超出数据库长度要求（长度：100），请删减."
                );
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        // 新建时，不校验必填，审核通过以后再维护时校验必填
        updateReason: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                this.$message.error("请输入修改原因");
                return callback(new Error(" "));
              }
              callback();
            },
            trigger: "blur",
          },
        ],
      },
      lastUpdateReason: "",
      detailForm: {
        category3Code: "",
        sponsorName: "",
        farmGroupId: "",
        auditStatus: "",
        farmName: "",
        varieties: [],
        farmAddress: "",
        plantingScale: "",
        crop: [],
        plantingMode: [],
        farmStatus: "",
        plantingPeriod: "",
        harvestTime: "",
        farmContacts: "",
        contactInformation: "",
        comments: "",
        updateReason: "",
      },
      returnForm: {
        returnedReason: "",
      },
      returnFormRules: {
        returnedReason: [
          { required: true, message: "请输入退回意见", trigger: "blur" },
        ],
      },
      tableData: [],
      fileList: [],
      category3CodeOptions: [],
      farmGroupOptions: [],
      auditStatusOptions: [],
      varietiesOptions: [],
      cropOptions: [],
      plantingModeOptions: [],
      farmStatusOptions: [],
      cropTempLists: [],

      rmcProduceFarmIds: [],
      isForbidden: false,
      dialogReturnVisible: false,
      isDisabled: true,
      ms_roles: null,
      rmcProduceFarmId: "",
    };
  },
  watch: {},
  created() {
    this.ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    this.$nextTick(() => {
      this.getSelection();
      this.getCrop()
      this.rmcProduceFarmId = this.$route.query.rmcProduceFarmId;
      if (this.$route.query.from === "edit") {
        if (this.$route.query.rmcProduceFarmId) {
          this.rmcProduceFarmIds.push(this.$route.query.rmcProduceFarmId);
        }
        this.getDetailInfo();
      } else {
        this.$set(this.detailForm, "auditStatus", "Draft");
        this.getSponsorByUser();
        this.getAuthorizedCategory3();
      }
    });
  },
  mounted() {},
  methods: {
    getDetailInfo() {
      rmcProdFarmApi
        .getFarmDetail(this.$route.query.rmcProduceFarmId)
        .then((res) => {
          console.log("获取农场明细", res);
          this.rmcProduceFarmId = res.data.rmcProduceFarmId;
          this.lastUpdateReason = res.data.updateReason;
          if (res.data.crop) {
            res.data.crop = res.data.crop.split(",");
          }
          if (res.data.varieties) {
            res.data.varieties = res.data.varieties.split(",");
          }
          if (res.data.plantingMode) {
            res.data.plantingMode = res.data.plantingMode.split(",");
          }
          this.detailForm = res.data;
          this.detailForm.updateReason = "";
          this.getFarmGroupList(res.data.sponsorCode, res.data.farmGroupId);
          if (
            res.data.auditStatus !== "PendingApproval" &&
            (this.ms_Permission.indexOf("RMC_PROD_FARM_SAVE") !== -1 ||
              this.ms_Permission.indexOf("RMC_PROD_FARM_SUBMIT") !== -1)
          ) {
            this.isForbidden = false;
          } else {
            this.isForbidden = true;
          }
        });
    },
    getSponsorByUser() {
      rmcProdFarmApi.getSponsorByUser().then((res) => {
        console.log("获取Sponsor", res);
        this.detailForm.sponsorName = res.data.supplierName;
        this.detailForm.sponsorCode = res.data.supplierCode;
        if (this.$route.query.from === "add") {
          this.getFarmGroupList(res.data.supplierCode);
        }
      });
    },
    getAuthorizedCategory3() {
      rmcProdFarmApi
        .getAuthorizedCategory3(this.$route.query.rmcProduceFarmId)
        .then((res) => {
          console.log("获取category3", res);
          this.category3CodeOptions = res.data.filter((v) => {
            return v.cascadeKey === "produce";
          });
          if (this.category3CodeOptions.length === 1) {
            this.detailForm.category3Code = this.category3CodeOptions[0].key;
            this.isDisabled = true;
          } else {
            this.isDisabled = false;
          }
        });
    },
    getSelection() {
      rmcProdFarmApi
        .getSelection([
          "rmc.RmcCategory3",
          "rmc.RmcAuditStatus",
          "rmc.RmcFarmPlantingMode",
          "rmc.RmcFarmProduceVarieties",
          "rmc.RmcFarmProduceCrop",
          "rmc.RmcProteinFarmStatus",
        ])
        .then((res) => {
          console.log("获取下拉框", res);
          this.category3CodeOptions = res.data["rmc.RmcCategory3"].filter(
            (v) => {
              return v.cascadeKey === "produce";
            }
          );
          console.log("this.category3CodeOptions", this.category3CodeOptions);
          this.auditStatusOptions = res.data["rmc.RmcAuditStatus"];
          this.varietiesOptions = res.data["rmc.RmcFarmProduceVarieties"];
          this.plantingModeOptions = res.data["rmc.RmcFarmPlantingMode"];
          this.farmStatusOptions = res.data["rmc.RmcProteinFarmStatus"];
        });
    },
    getCrop() {
      rmcProdFarmApi
        .getCrop({
          "TT_RMC_PRODUCE_FARM:CROP": "TT_RMC_PRODUCE_FARM:CROP",
        })
        .then((res) => {
          console.log("rea", res);
          this.cropTempLists = res["TT_RMC_PRODUCE_FARM:CROP"];
          this.cropOptions = res["TT_RMC_PRODUCE_FARM:CROP"];
        });
    },
    getFarmGroupList(sponsor, farmGroupId) {
      rmcProdFarmApi.getFarmGroupList(sponsor).then((res) => {
        console.log("获取Farm Group", res);
        this.farmGroupOptions = res.data;
        var codeLists = res.data.map((ele) => {
          return ele.rmcProduceFarmGroupId;
        });
        console.log("codeLists", codeLists);
        if (farmGroupId && !codeLists.includes(farmGroupId)) {
          this.farmGroupOptions.push({
            rmcProduceFarmGroupId: this.detailForm.farmGroupId,
            farmGroup: this.detailForm.farmGroup,
            enabled: true,
            sponsorCode: sponsor,
          });
        }
        console.log("this.farmGroupOptions", this.farmGroupOptions);
      });
    },
    onAddSave() {
      this.$refs["detailForm"].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            farmGroupId: this.detailForm.farmGroupId,
            farmName: this.detailForm.farmName,
            farmAddress: this.detailForm.farmAddress,
            plantingScale: this.detailForm.plantingScale,
            varietieses: this.detailForm.varieties,
            crops: this.detailForm.crop,
            plantingModes: this.detailForm.plantingMode,
            farmStatus: this.detailForm.farmStatus,
            plantingPeriod: this.detailForm.plantingPeriod,
            harvestTime: this.detailForm.harvestTime,
            farmContacts: this.detailForm.farmContacts,
            contactInformation: this.detailForm.contactInformation,
            comments: this.detailForm.comments,
            updateReason: this.detailForm.updateReason,
          };
          rmcProdFarmApi.addFarm(obj).then((res) => {
            console.log("保存", res);
            if (res.meta.code === 200) {
              this.$message.success("保存成功");
              this.$router.push("/rmcProdFarm");
            } else {
              this.$message.error(res.meta.msg);
            }
          });
        }
      });
    },
    onEditSave() {
      this.$refs["detailForm"].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            farmGroupId: this.detailForm.farmGroupId,
            farmName: this.detailForm.farmName,
            farmAddress: this.detailForm.farmAddress,
            plantingScale: this.detailForm.plantingScale,
            varietieses: this.detailForm.varieties,
            crops: this.detailForm.crop,
            plantingModes: this.detailForm.plantingMode,
            farmStatus: this.detailForm.farmStatus,
            plantingPeriod: this.detailForm.plantingPeriod,
            harvestTime: this.detailForm.harvestTime,
            farmContacts: this.detailForm.farmContacts,
            contactInformation: this.detailForm.contactInformation,
            comments: this.detailForm.comments,
            updateReason: this.detailForm.updateReason,
          };
          rmcProdFarmApi.updateFarm(this.rmcProduceFarmId, obj).then((res) => {
            console.log("更新", res);
            if (res.meta.code === 200) {
              this.$message.success("保存成功");
              this.$router.push("/rmcProdFarm");
            } else {
              this.$message.error(res.meta.msg);
            }
          });
        }
      });
    },
    cropChange(val) {
      console.log("cropOptions", this.cropOptions);
      console.log("val", val);
      this.detailForm.varieties = [];
      var cropTempLists = this.cropOptions
        .filter((ele) => {
          return val.includes(ele.code);
        })
        .map((item) => {
          return item.restrictFieldName1;
        });
      console.log("cropTempLists", cropTempLists);
      this.detailForm.varieties = this.varietiesOptions
        .filter((ele) => {
          return cropTempLists.includes(ele.key);
        })
        .map((item) => {
          return item.key;
        });
      console.log("this.detailForm.varieties", this.detailForm.varieties);
    },
    onSubmit() {
      this.$refs["detailForm"].validate((valid) => {
        if (valid) {
          var obj = {
            category3Code: this.detailForm.category3Code,
            sponsorCode: this.detailForm.sponsorCode,
            farmGroupId: this.detailForm.farmGroupId,
            farmName: this.detailForm.farmName,
            farmAddress: this.detailForm.farmAddress,
            plantingScale: this.detailForm.plantingScale,
            varietieses: this.detailForm.varieties,
            crops: this.detailForm.crop,
            plantingModes: this.detailForm.plantingMode,
            farmStatus: this.detailForm.farmStatus,
            plantingPeriod: this.detailForm.plantingPeriod,
            harvestTime: this.detailForm.harvestTime,
            farmContacts: this.detailForm.farmContacts,
            contactInformation: this.detailForm.contactInformation,
            comments: this.detailForm.comments,
            updateReason: this.detailForm.updateReason,
          };
          rmcProdFarmApi.submitFarm(this.rmcProduceFarmId, obj).then((res) => {
            if (res.meta.code === 200) {
              this.$message.success("提交成功");
              this.$router.push("/rmcProdFarm");
            } else {
              this.$message.error(res.meta.msg);
            }
          });
        }
      });
    },
    onApprove() {
      rmcProdFarmApi
        .approveFarm({
          rmcProduceFarmIds: this.rmcProduceFarmIds,
        })
        .then((res) => {
          if (res.meta.code === 200) {
            this.$message.success("批准成功");
            this.$router.push("/rmcProdFarm");
          } else {
            this.$message.error(res.meta.msg);
          }
        });
    },
    onReturn() {
      this.dialogReturnVisible = true;
    },
    onConfirm() {
      this.$refs["returnForm"].validate((valid) => {
        if (valid) {
          rmcProdFarmApi
            .returnFarm({
              rmcProduceFarmIds: this.rmcProduceFarmIds,
              returnedReason: this.returnForm.returnedReason,
            })
            .then((res) => {
              if (res.meta.code === 200) {
                this.$message.success("退回成功");
                this.onClose();
                this.$router.push("/rmcProdFarm");
              } else {
                this.$message.error(res.meta.msg);
              }
            });
        }
      });
    },
    onClose() {
      this.dialogReturnVisible = false;
      this.returnForm.returnedReason = "";
    },
    routerBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
</style>